import SetupCC from "components/setupCC";
import InputField from "components/ui/inputField";
import * as yup from "yup";

const ExpenseItems = () => {
  const initialValues = {
    name: "",
    description: "",
  };

  return (
    <SetupCC
      name="Expense Item"
      baseRouteKey="expenseItems"
      moduleKey="expense-item"
      columns={[
        { id: "name", label: "Item Name", minWidth: 100 },
        { id: "amount", label: "Amount", minWidth: 100 },
        { id: "description", label: "Description", minWidth: 100 },
        {
          id: "action",
          label: "Actions",
          style: { width: "150px" },
          align: "center",
        },
      ]}
      actions={["edit", "delete"]}
      getInitialValues={(data) => {
        if (data?.id) {
          let obj = {};
          for (const key in initialValues) {
            obj[key] = data[key];
          }
          return obj;
        } else return initialValues;
      }}
      validationSchema={yup.object({
        name: yup.string().required("Name is required!"),
      })}
      allFields={(formik) => (
        <>
          <InputField name="name" label="Expense Item Name" formik={formik} />
          <InputField
            type="number"
            name="amount"
            label="Amount"
            formik={formik}
          />
          <InputField
            name="description"
            label="Description"
            rows={3}
            multiline
            formik={formik}
          />
        </>
      )}
    ></SetupCC>
  );
};

export default ExpenseItems;
